export const CatalogueLayout = ({ description, title, details, children }) => {
  return (
    <div>
      <div className="bg-[#F6F7F6] border border-[#E1E6E1] rounded-t-lg h-[42px] py-3 px-4">
        <p className="text-[#3E473F] text-sm font-semibold">{title}</p>
      </div>
      <div className="bg-[#FFF] border border-[#E1E6E1] border-t-0 rounded-b-lg h-fit py-3 ">
        {details ? (
          <div>{children}</div>
        ) : (
          <p className="text-[#5F6D60] text-sm font-medium px-4">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};
